import React, { useEffect, useState } from "react";
import CookieConsent from 'react-cookie-consent';
import { storedCookiesConsent, getIPAndLocation } from '@/api/dictionaryAPI';
import { isEmpty } from "lodash";
import { Link, useOutletContext } from "react-router-dom";
import { publicRoutePaths } from "@/routes/public.routes.config";

const ConsentManager = ({ data }) => {
  const [showConsent, setShowConsent] = useState(false);
  const deviceData = useOutletContext();

  const detectArchitecture = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();

    if (
      platform.includes('win64') ||
      platform.includes('x64') ||
      platform.includes('x86_64') ||
      platform.includes('amd64') ||
      platform.includes('arm64')
    ) {
      return '64-bit';
    } else if (
      platform.includes('win32') ||
      platform.includes('x86') ||
      platform.includes('arm')
    ) {
      return '32-bit';
    } else if (userAgent.includes('wow64') || userAgent.includes('win64') || userAgent.includes('x64')) {
      return '64-bit';
    } else if (userAgent.includes('win32') || userAgent.includes('x86')) {
      return '32-bit';
    }

    if (navigator.hardwareConcurrency) {
      return navigator.hardwareConcurrency > 4 ? '64-bit (likely)' : '32-bit (likely)';
    }
    return 'Unknown';
  };

  const getDeviceType = () => {
    const userAgent = navigator.userAgent;
    const screenWidth = window.screen.width;

    const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent);

    if (isTablet || (screenWidth >= 768 && screenWidth <= 1024 && isMobile)) {
      return 'Tablet';
    } else if (isMobile || screenWidth < 768) {
      return 'Mobile';
    } else {
      return 'Desktop';
    }
  };

  const getPageVisitCount = () => {
    const count = parseInt(localStorage.getItem('pageVisitCount') || '0', 10) + 1;
    localStorage.setItem('pageVisitCount', count);
    return count;
  };

  // Collect all tracking data
  const collectTrackingData = async (ipInfo) => {
    const architecture = detectArchitecture();
    const deviceType = getDeviceType();
    const visitCount = getPageVisitCount();

    const trackingData = {
      timestamp: new Date().toISOString(),
      pageVisitCount: visitCount,
      ip: ipInfo?.ip,
      country: ipInfo?.country,
      city: ipInfo?.city,
      region: ipInfo?.region,
      pageUrl: window.location.href,
      referrer: document.referrer,
      deviceType,
      browser: deviceData?.deviceInfo?.browser,
      browserVersion: deviceData?.deviceInfo?.browserVersion,
      // os,
      architecture,
      platform: deviceData?.deviceInfo?.platform,
      platformVersion: deviceData?.deviceInfo?.platformVersion,
      // userAgent: navigator.userAgent,
      language: navigator.language,
      timezone: ipInfo?.timezone
      // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      // touchSupport: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    };

    return trackingData;
  };

  // Helper to set cookie
  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
  };

  useEffect(() => {
    // Delay showing the cookie consent by 2 seconds (2000ms)
    const timer = setTimeout(() => {
      setShowConsent(true);
    }, 2000); // Adjust delay time as needed

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  // On cookie consent accept
  const handleAccept = async () => {
    try {
      let currentIpData = data;
      if (isEmpty(data.ip)) {
        currentIpData = await getIPAndLocation();
      }
      const trackingData = await collectTrackingData(currentIpData);
      setCookie('user_consent', JSON.stringify(trackingData), 365);
      const response = await storedCookiesConsent(trackingData, 'Accept');
      if (response.status === true) {
        console.log("Cookies Accept!");
      } else {
        console.log("Something wrong!");
      }
    } catch (err) {
      console.error("Error fetching data:", err);

    }
  };

  const handleDecline = async () => {
    try {
      let currentIpData = data;
      if (isEmpty(data.ip)) {
        currentIpData = await getIPAndLocation();
      }
      const trackingData = await collectTrackingData(currentIpData);
      const response = await storedCookiesConsent(trackingData, 'Reject');
      setCookie('user_consent', 'declined', 365);
      if (response.status === true) {
        console.log("Cookies Reject!");
      } else {
        console.log("Something wrong!");
      }

    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  return (
    <>
      {showConsent && (
        <CookieConsent
          location="bottom"
          enableDeclineButton
          declineButtonText="Decline"
          buttonText="Accept All"
          cookieName="agent"
          style={{
            background: '#3c3b3b',
            color: '#c9e7ff',
          }}
          buttonStyle={{
            color: '#fff',
            fontSize: '14px',
            background: '#2e9bf0',
            padding: '10px 24px',
            borderRadius: '6px',
            fontWeight: '500',
            border: '1px solid rgba(68, 166, 241, 1)',
            borderRadius: '24px',
          }}
          declineButtonStyle={{
            color: '#fff',
            background: '#df0024',
            fontSize: '14px',
            padding: '10px 24px',
            borderRadius: '6px',
            fontWeight: '500',
            borderRadius: '24px',
          }}
          expires={365}
          onAccept={handleAccept}
          onDecline={handleDecline}
        >
          We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also disclose information about your use of our site with our social media, advertising and analytics partners. Additional details are available in our <Link to={publicRoutePaths.PRIVACY_POLICY.path} href={publicRoutePaths.PRIVACY_POLICY.path} title="Privacy Policy" target="_blank" >Cookie Policy</Link>
        </CookieConsent>
      )}
    </>
  );
};

export default ConsentManager;
